export default __webpack_public_path__ + "static/media/gallery02.99412690.png";